import { AuthProvider, AuthOptions } from "./authProviderInterface";
import { setupCognito, getToken, logoutCognito } from "./cognitoAuth";

export class CognitoAuthProvider implements AuthProvider {
    install(Vue: any, options: AuthOptions): void {
        // Cognito setup is handled via interceptors
        this.setupInterceptors();
    }

    async getToken(): Promise<string | undefined> {
        return await getToken();
    }

    logout(): void {
        logoutCognito();
    }

    logoutRedirect(): void {
        // Cognito's hosted-UI logout is already a full-page redirect to its configured logout URI.
        logoutCognito();
    }

    async signOutEmbedded(): Promise<void> {
        // Clearing only the stored tokens would not sign the user out: the hosted UI's session cookie
        // outlives them, so the sign-in redirect on reload would come straight back with a new code.
        // The hosted-UI logout ends that session. Its sign-in page may then refuse to render in the
        // frame, but a blank frame fails closed.
        logoutCognito();
    }

    setupInterceptors(): void {
        setupCognito();
    }
}